import OurMissionSvg from '../../../assets/HomePage/OurMission.svg'

export const OurMission = () => {
    return (
        <section className="w-full bg-gradient-to-r from-primary-300 to-secondary-300 min-h-[350px] md:min-h-[410px] py-12 px-6 md:px-16 lg:px-24 xl:px-36 flex flex-col items-center justify-center space-y-3 md:space-y-5">
            {/* Icon */}
            <div className="flex justify-center">
                <img src={OurMissionSvg} alt="Our Mission" className="w-14 md:w-16 lg:w-20" />
            </div>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center">
                Our Mission
            </h2>

            {/* Sub Heading */}
            <div className="flex justify-center">
                <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl text-white font-semibold text-center max-w-[95%] md:max-w-[750px] lg:max-w-[900px]">
                    "To make hiring fast, fair, and future-ready for everyone, everywhere."
                </h3>
            </div>
        </section>
    )
}
